import Dropdown from '@/components/atoms/project-builder/dropdown';
import { useFormat } from '@/helpers/hooks/useFormat';
import React, { useCallback, useMemo } from 'react';
import { useSortBy, UseSortByProps } from 'react-instantsearch-hooks';

const SortFacet: React.FC<UseSortByProps> = (props) => {
  const { currentRefinement, options, refine } = useSortBy(props);
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });
  // const [isTabletSize] = useMediaQuery(desktop);

  const sortDropdownButton = useMemo(() => {
    
    return (
      <div className="flex w-full items-center justify-center gap-[6px] 2xl:gap-[16px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
          <path
            d="M8.66756 4.62479L7.48906 5.8033L5.37672 3.69L5.37609 14.6667H3.70943L3.71005 3.69L1.59649 5.8033L0.417969 4.62479L4.54276 0.5L8.66756 4.62479ZM17.0009 11.3752L12.8761 15.5L8.75131 11.3752L9.92981 10.1967L12.0434 12.31L12.0427 1.33333H13.7094L13.7101 12.31L15.8224 10.1967L17.0009 11.3752Z"
            fill="#090909"
          />
        </svg>
        <span className="text-[16px] font-medium  md:text-[14px] 2xl:text-[16px]">
          {formatProductMessage({ id: 'sortBy', defaultMessage: 'Sort' })}
        </span>
      </div>
    );
  }, []);
  const sortDropdownButtonClassnames = useCallback((open?: boolean) => {
    return `px-2 py-3 text-14  relative overflow-hidden rounded-md font-medium leading-4 transition disabled:pointer-events-none border border-gray-700  text-gray-700   hover:disabled:shadow-none  focus:outline-[3px]  disabled:border disabled:border-gray-300 disabled:bg-white disabled:text-gray-400`;
  }, []);
  return (
    <div>
      <Dropdown
        customButtonElement={sortDropdownButton}
        customButtonClassNames={sortDropdownButtonClassnames}
        customMenuWrapperClassNames={
          'absolute !z-40 mt-[10px] lg:mt-[2px]  lg:w-full left-0 -mr-[24px] min-[800px]:-mr-[42px] lg:mr-0 z-[99] focus:border-none focus:outline-none min-w-[10rem] 2xl:min-w-[14rem] rounded-none max-h-[400px] overflow-y-auto'
        }
      >
        {options.map(({ label, value }) => (
          <div
            key={value}
            onClick={() => refine(value)}
            className={`cursor-pointer border-b border-neutral-300 px-[24px] md:px-[32px] py-[14px] text-[16px] transition hover:bg-transparent md:text-[14px] lg:p-[14px] 2xl:text-[16px] text-left ${
              value === currentRefinement ? 'bg-transparent' : 'bg-neutral-200'
            }`}
          >
            {label}
          </div>
        ))}
      </Dropdown>
      {/* {isTabletSize ? (
      ) : (
        <div>
          {options.map(({ label, value }) => (
            <div
              key={value}
              onClick={() => refine(value)}
              className={`cursor-pointer px-[24px] py-[12px] transition hover:bg-neutral-200 ${
                value === currentRefinement ? 'bg-neutral-200' : 'bg-transparent'
              }`}
            >
              {label}
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default SortFacet;
